export const JOB_ROLES = Object.freeze({
    PRODUCT_MANAGEMENT: {
        key: 'PRODUCT_MANAGEMENT',
        label: 'Product Management',
    },
    PRODUCT_OPERATIONS: {
        key: 'PRODUCT_OPERATIONS',
        label: 'Product Operations',
    },
    PRODUCT_DESIGN: {
        key: 'PRODUCT_DESIGN',
        label: 'Product Design',
    },
    RESEARCH: {
        key: 'RESEARCH',
        label: 'Research',
    },
    CUSTOMER_SUCCESS: {
        key: 'CUSTOMER_SUCCESS',
        label: 'Customer Success',
    },
    SUPPORT: {
        key: 'SUPPORT',
        label: 'Support',
    },
    PRESIDENT_CEO: {
        key: 'PRESIDENT_CEO',
        label: 'President / CEO',
    },
    ENGINEERING: {
        key: 'ENGINEERING',
        label: 'Engineering',
    },
    MARKETING: {
        key: 'MARKETING',
        label: 'Marketing',
    },
    OTHER: {
        key: 'OTHER',
        label: 'Other',
    },
});
